//context to set a flag when user leave/join team to effect on header dropdown
import React, { createContext, useState } from 'react';

//interface of the context object
interface ITeamContextValue {
  isTeamchanged: boolean;
  setIsTeamchanged: (isTeamchanged: boolean) => void;
}

//inital values for the context object
const TeamContext = createContext<ITeamContextValue>({
  isTeamchanged: false,
  setIsTeamchanged: () => {},
});

const TeamProvider = (props: any) => {
  const [teamchanged, setTeamchanged] = useState(false);

  async function updateTeamChanged(isTeamchanged: boolean) {
    setTeamchanged(isTeamchanged);
  }

  const contextValue: ITeamContextValue = {
    isTeamchanged: teamchanged,
    setIsTeamchanged: updateTeamChanged,
  };

  return <TeamContext.Provider value={contextValue} {...props} />;
};

const useTeam = () => React.useContext(TeamContext);

export { TeamProvider, useTeam };
